var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "download-cover-config download-video-config-section" },
    [
      _c(
        "div",
        { staticClass: "download-video-config-item" },
        [
          _c("div", { staticClass: "download-video-config-title" }, [
            _vm._v("封面:"),
          ]),
          _vm._v(" "),
          _c("VDropdown", {
            attrs: { items: _vm.items },
            scopedSlots: _vm._u([
              {
                key: "item",
                fn: function ({ item }) {
                  return [_vm._v("\n        " + _vm._s(item) + "\n      ")]
                },
              },
            ]),
            model: {
              value: _vm.type,
              callback: function ($$v) {
                _vm.type = $$v
              },
              expression: "type",
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }